import React from "react";
import { QueryClientProvider, QueryClient, QueryCache } from "react-query";
import { fetchApi } from "./reactQueryApi";
import { isString } from "lodash";

const queryCache = new QueryCache();
const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      queryFn: async ({ queryKey }) =>
        isString(queryKey[0]) && fetchApi(queryKey[0]),
    },
  },
});

function Wrapper({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}

window.queryClient = queryClient;

export default queryClient;
export { queryClient, queryCache, Wrapper };
